"use client";

import React from "react";
import { ENVIRONMENT, IS_PRODUCTION } from "@/constants/envs";
import Script from "next/script";
import useCookieConsent from "@/hooks/utils/useCookieConsent";

const MetaScripts = () => {
  const { cookieConsent } = useCookieConsent();

  const addScripts = cookieConsent && IS_PRODUCTION;

  return (
    <>
      <Script src="/js/intercom.js" async strategy="lazyOnload" />
      {IS_PRODUCTION && (
        <>
          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-549CZKJM"
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
            ></iframe>
          </noscript>
          {/* <!-- End Google Tag Manager (noscript) --> */}
          {GoogleAnalytics()}

          {/* Microsoft Clarity */}
          {MicrosoftClarity()}
        </>
      )}
      {addScripts && (
        <>
          {/* <!-- Google Tag Manager --> */}
          {/* eslint-disable-next-line @next/next/next-script-for-ga */}
          {/* <Script
            async
            src="https://www.googletagmanager.com/gtag/js?id=GTM-WCTZ8FN"
          ></Script> */}
          {/* <!-- Google Tag Manager (noscript) --> */}

          {/* This is for facebook pixel */}
          <meta
            name="facebook-domain-verification"
            content="nw4ejno7jllu3ujj51t0naxs2qgr92"
          />
          {/* <!-- Meta Pixel Code --> */}
          {facebookPixelAds()}

          {/* <noscript>
            <img
              alt=""
              height="1"
              width="1"
              style={{ display: "none" }}
              src="https://www.facebook.com/tr?id=5386611248071915&ev=PageView&noscript=1"
            />
          </noscript> */}

          {/* <!-- Hotjar Tracking Code for https://sendsprint.com --> */}
          {HotJar()}
          {/* <!-- Tiktok Tracking Code for https://sendsprint.com --> */}
          {Tiktok()}
        </>
      )}
    </>
  );
};

function googleAnalyticsMarkUp() {
  return {
    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-549CZKJM');`,
  };
}

function GoogleAnalytics() {
  return (
    <Script
      id="googleAnalytics"
      dangerouslySetInnerHTML={googleAnalyticsMarkUp()}
    />
  );
}

function microsoftClarityMarkUp() {
  return {
    __html: `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "spj0x7iw7d");`,
  };
}

function MicrosoftClarity() {
  return (
    <Script
      id="microsoftClarity"
      dangerouslySetInnerHTML={microsoftClarityMarkUp()}
    />
  );
}

function facebookPixelAds() {
  return (
    <Script id="fbPixel" dangerouslySetInnerHTML={facebookPixelsMarkup()} />
  );
}

function facebookPixelsMarkup() {
  return {
    __html: `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '5386611248071915');
      fbq('track', 'PageView');`,
  };
}

function tiktokMarkup() {
  return {
    __html: `
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
      
        ttq.load('CL1O32BC77UD28E1JNR0');
        ttq.page();
      }(window, document, 'ttq');
      `,
  };
}

function Tiktok() {
  return <Script id="tiktok" dangerouslySetInnerHTML={tiktokMarkup()} />;
}

function hotjarMarkup() {
  return {
    __html: `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2813088,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
  };
}

function HotJar() {
  return <Script id="hotjar" dangerouslySetInnerHTML={hotjarMarkup()} />;
}

export default MetaScripts;
